module.exports = __webpack_public_path__ + "img/spoken_al_detail_back.ce474f6d.svg";